var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "file-chooser-box",
    },
    [
      _c(
        "header",
        [
          _c("file-chooser-breadcrumb", {
            attrs: {
              folders: _vm.folders,
            },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "toggle-view",
              attrs: {
                title: _vm.$gettext("Rasteransicht umschalten"),
              },
              on: {
                click: _vm.toggleGrid,
              },
            },
            [
              _c("studip-icon", {
                attrs: {
                  shape: _vm.showGrid ? "view-list" : "view-wall",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showMessageBox
        ? _c(
            "div",
            {
              staticClass: "messagebox messagebox_success",
            },
            [
              _c(
                "div",
                {
                  staticClass: "messagebox_buttons",
                },
                [
                  _c("a", {
                    staticClass: "close",
                    attrs: {
                      href: "#",
                      title: _vm.$gettext("Nachrichtenbox schließen"),
                    },
                    on: {
                      click: function click($event) {
                        $event.preventDefault()
                        _vm.showMessageBox = false
                      },
                    },
                  }),
                ]
              ),
              _vm._v("\n        " + _vm._s(_vm.successMessage) + "\n    "),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.contentForbidden
        ? _c(
            "div",
            {
              staticClass: "messagebox messagebox_error",
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$gettext(
                      "Sie sind nicht berechtigt, den Inhalt dieses Ordners anzuzeigen."
                    )
                  ) +
                  "\n    "
              ),
            ]
          )
        : _c(
            "div",
            {
              staticClass: "file-chooser-box-content",
            },
            [
              _vm.showGrid
                ? _c(
                    "div",
                    {
                      staticClass: "file-chooser-items",
                    },
                    [
                      !_vm.isEmpty
                        ? [
                            _vm._l(_vm.subFolders, function (folder) {
                              return _c("file-chooser-folder-item", {
                                key: folder.id,
                                attrs: {
                                  folder: folder,
                                },
                              })
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.currentFolderFiles, function (file) {
                              return _c("file-chooser-file-item", {
                                key: file.id,
                                attrs: {
                                  file: file,
                                },
                                on: {
                                  selectId: function selectId($event) {
                                    return _vm.$emit("selectId")
                                  },
                                },
                              })
                            }),
                            _vm._v(" "),
                            _vm.loadingFiles
                              ? _c("studip-progress-indicator", {
                                  attrs: {
                                    description: _vm.$gettext("Lade Dateien…"),
                                  },
                                })
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isEmpty ? _c("file-chooser-empty") : _vm._e(),
                    ],
                    2
                  )
                : _c("file-chooser-table", {
                    attrs: {
                      files: _vm.currentFolderFiles,
                      subfolders: _vm.subFolders,
                      empty: _vm.isEmpty,
                    },
                    on: {
                      selectId: function selectId($event) {
                        return _vm.$emit("selectId")
                      },
                    },
                  }),
              _vm._v(" "),
              _c("file-chooser-toolbar", {
                class: {
                  "with-table": !_vm.showGrid,
                },
                on: {
                  fileAdded: _vm.fileAdded,
                  folderAdded: _vm.folderAdded,
                },
              }),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }